import userStore from "./userStore";
import productsStore from "./productsStore";
import ordersStore from "./ordersStore";
import projectsStore from "./projectsStore";
const stores = {
  userStore,
  productsStore,
  ordersStore,
  projectsStore,
};

export { userStore, productsStore, ordersStore, projectsStore };

export default stores;
